import Close from 'styles/icons/CloseIcon';
import styled from '@emotion/styled';

const CloseIcon = styled(Close)({
  height: '1.3rem',
  width: '1.3rem',
});

export default CloseIcon;
